import React from 'react';
import { Link } from 'react-router-dom';
import { SignIn } from '@clerk/clerk-react';

/**
 * Sign-in page. Embedded Clerk component - stays on site, matches appearance.
 */
const SignInPage = () => (
  <div className="auth-page" style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', minHeight: '100vh', padding: '1rem', background: 'var(--cr-bg)' }}>
    <SignIn
      routing="path"
      path="/sign-in"
      signUpUrl="/sign-up"
      afterSignInUrl="/"
    />
    <div style={{ marginTop: '1.25rem', fontSize: '0.9rem', color: 'var(--cr-text-muted)', textAlign: 'center', maxWidth: '22rem', lineHeight: 1.6 }}>
      <p style={{ margin: '0 0 0.5rem 0' }}>No account yet? Public pages (no sign-in):</p>
      <ul style={{ margin: 0, paddingLeft: '1.2rem', textAlign: 'left' }}>
        <li><Link to="/faqs" style={{ color: 'var(--cr-link)', textDecoration: 'underline' }}>FAQs</Link></li>
        <li><Link to="/accessibility" style={{ color: 'var(--cr-link)', textDecoration: 'underline' }}>Accessibility Statement</Link></li>
        <li><Link to="/how-to" style={{ color: 'var(--cr-link)', textDecoration: 'underline' }}>Invitation &amp; sign up</Link></li>
        <li><Link to="/sign-up" style={{ color: 'var(--cr-link)', textDecoration: 'underline' }}>Create account (sign up)</Link></li>
      </ul>
    </div>
  </div>
);

export default SignInPage;
